/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import CssPinner from '/client/src/components/csspinner';
import { GET, PUT } from '/client/src/api';

type PropsType = {
  eventId: number | string
};

const items = [
  {
    id: 1,
    label: 'Event Status',
    image: 'img-1',
    link: null
  },
  {
    id: 2,
    label: 'Scheduled Emails',
    image: 'img-2',
    link: 'reminders'
  },
  {
    id: 3,
    label: 'Resend Email',
    image: 'img-3',
    link: 'resend'
  },
  {
    id: 4,
    label: 'Void & Refund',
    image: 'img-4',
    link: 'refund'
  },
  {
    id: 5,
    label: 'Track Referral Links',
    image: 'img-5',
    link: 'ref-links'
  },
  {
    id: 6,
    label: 'Add Guests',
    image: 'img-6',
    link: 'import'
  },
  {
    id: 7,
    label: 'Integration Codes & URLs',
    image: 'img-7',
    link: 'codes'
  },
  {
    id: 8,
    label: 'Collaborate',
    image: 'img-8',
    link: 'collaborators'
  },
  {
    id: 9,
    label: 'Physical Ticket',
    image: 'img-9',
    link: 'physical-ticket'
  },
  {
    id: 11,
    label: 'Discount Codes',
    image: 'img-11',
    link: 'discount-codes/codes'
  },
  {
    id: 13,
    label: 'VIP Codes',
    image: 'img-12',
    link: 'vip-codes/codes'
  }
];

const featuresItems = {
  // eslint-disable-next-line camelcase
  badge_printing: {
    id: 15,
    label: 'Badge Printing',
    image: 'img-15',
    link: 'badge-printing'
  },
  // eslint-disable-next-line camelcase
  self_checkin: {
    id: 10,
    label: 'Self Check-in Settings',
    image: 'img-10',
    link: 'self-checkin'
  },
  sponsor: {
    id: 12,
    label: 'Sponsor',
    image: 'img-13',
    link: 'sponsor'
  }
};

const EventPageDetailManage = (props: PropsType): React.Element<'div'> => {
  const { eventId } = props;
  const EventDetailContext = React.useContext(EventDetailContainerContext);
  const [eventStatus, setEventStatus] = React.useState(EventDetailContext.eventDetail.status === 'Active' || EventDetailContext.eventDetail.status === 'Open');
  const context = React.useContext(DefaultContainerContext);
  const statusCard = React.useRef();
  const readonlyPermissionItemIds = [5, 7, 8, 9];
  const isReadonlyPermission = _.get(EventDetailContext, 'eventDetail.permission', 'Write') === 'Read';
  const [currentItems, setCurrentItems] = React.useState(items);

  const statusAPIRequest = async (status: boolean, callback: (any) => void) => {
    try {
      CssPinner(statusCard.current, true);
      await PUT(`/api/v1/1/events/${eventId}/${status ? 'publish' : 'unpublish'}`);

      // eslint-disable-next-line
      callback();

      CssPinner(statusCard.current, false);
    } catch (error) {
      console.log(error);
      console.error('Cant change event status');
      CssPinner(statusCard.current, false);
    }
  };

  const handleChangeEventStatus = async (e: SyntheticEvent<HTMLLinkElement>) => {
    e.preventDefault();

    if (!eventStatus) {
      // eslint-disable-next-line
      statusAPIRequest(true, () => setEventStatus(true));
    } else {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'warning',
        systemDialogTitle: 'Hmmm...',
        systemDialogContent: 'Unpublish this event?',
        systemDialogData: {
          setEventStatus,
          eventStatus
        },
        systemDialogCallback: statusAPIRequest
      });
    }
  };

  const getFeaturesItems = async () => {
    const newItems = _.cloneDeep(currentItems);

    try {
      let isMailChimp = JSON.parse(localStorage.getItem('isMailChimpConnected'));

      if (isMailChimp === null) {
        const { result } = await GET('/api/v1/1/mailchimp');

        const isEnable = _.get(result, 'enable', false);

        window.localStorage.setItem('isMailChimpConnected', isEnable);

        isMailChimp = isEnable;
      }

      if (isMailChimp) {
        featuresItems.mailchimp = {
          id: 14,
          label: 'Mailchimp',
          image: 'img-14',
          link: 'mailchimp'
        };
      }
    } catch (e) {
      console.log(e);
    }

    for (const key in featuresItems) {
      if (
        context.profileCurrent[`is_enable_${key}`]
        &&
        featuresItems.hasOwnProperty(key)
        &&
        !_.find(currentItems, (e) => e.id === featuresItems[key].id)
      ) {
        newItems.push(featuresItems[key]);
      }
    }

    if (isReadonlyPermission) {
      newItems.filter(x => readonlyPermissionItemIds.includes(x.id));
    }

    setCurrentItems(newItems.sort((a, b) => a.id - b.id));
  };

  React.useEffect(() => {
    getFeaturesItems();
  }, [context.profileCurrent]);

  return (
    <div className="row sparxo-manage-cards">
      {
        !isReadonlyPermission &&
        <div className="item x-5">
          <a
            ref={statusCard}
            href={currentItems[0].link}
            className={`sparxo-manage-card ${currentItems[0].image}`}
            onClick={(e: SyntheticEvent<HTMLLinkElement>) => {
              handleChangeEventStatus(e);
            }}
            style={{
              cursor: 'pointer'
            }}
          >
            <i className="img" />
            <span>{currentItems[0].label}</span>
            <span className={`event-state ${eventStatus ? 'active' : ''}`}>
            {eventStatus ? 'live' : 'off'}
          </span>
          </a>
        </div>
      }
      {_.map(_.slice(currentItems, isReadonlyPermission ? 0 : 1), (i: {}, k: number): React.Element<'a'> => {
        return (
          <div key={`EventPageDetailManage-${k}`} className="item x-5">
            <Link
              to={`/events/${eventId}/manage/${i.link}`}
              className={`sparxo-manage-card ${i.image}`}
            >
              <i className="img" />
              <span>{i.label}</span>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default withRouter(EventPageDetailManage);
